import React from 'react';
import './RefundPolicyModal.scss';

const RefundPolicyModal = ({ onClose }) => {
  return (
    <div className="refund-modal-overlay" onClick={onClose}>
      <div className="refund-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>환불 정책</h2>
          <button className="btn-close" onClick={onClose}>×</button>
        </div>
        
        <div className="modal-body">
          <section>
            <h3>1. 기본 원칙</h3>
            <p>본 서비스는 디지털 콘텐츠(매쓰테일러 이용권) 상품으로, 결제 완료 후 즉시 이용이 가능한 상품입니다.</p>
          </section>

          <section>
            <h3>2. 환불 기준</h3>
            <h4>① 미사용 이용권</h4>
            <p>결제 후 사용 이력이 없는 경우, 결제일로부터 7일 이내 전액 환불 가능합니다.</p>
            
            <h4>② 일부 사용한 경우</h4>
            <p>이용권의 일부를 사용한 경우, 사용한 분량(페이지 수)을 제외한 잔여 금액에 대해 환불이 가능합니다.</p>
            <p>환불 금액 = 구매 금액 × (잔여 페이지 수 / 총 페이지 수)</p>
            
            <h4>③ 전액 사용한 경우</h4>
            <p>이용권을 모두 사용한 경우에는 환불이 불가능합니다.</p>

            <h4>④ 환불 가능 기간에 관한 추가 기준</h4>
            <p>결제일로부터 1개월이 지난 이용권은 원칙적으로 환불이 어렵습니다.</p>
            <p>다만, 관련 법령에 따라 환불이 인정되는 경우, 회사의 귀책 사유로 서비스를 정상적으로 이용할 수 없는 경우, 또는 결제 오류·중복 결제 등 명백한 결제 이상이 확인되는 경우에는 예외적으로 환불이 가능합니다.</p>
          </section>

          <section>
            <h3>3. 환불 불가 사유</h3>
            <ul>
              <li>이용권 사용 이력이 확인되는 경우 (사용량에 따른 부분 환불 가능)</li>
              <li>서비스 특성상 재판매가 불가능한 경우</li>
              <li>이용자의 귀책 사유로 서비스 이용이 불가능한 경우</li>
              <li>부정한 방법으로 이용권을 취득하거나 사용한 경우</li>
            </ul>
          </section>

          <section>
            <h3>4. 환불 처리 기간</h3>
            <ul>
              <li>환불 요청 접수 후 영업일 기준 3~5일 이내 처리됩니다.</li>
              <li>결제 수단에 따라 환불 완료까지 추가 기간이 소요될 수 있습니다.</li>
              <li>신용카드 결제의 경우, 카드사 정책에 따라 환불 승인 후 1~2개월의 시간이 소요될 수 있습니다.</li>
            </ul>
          </section>

          <section>
            <h3>5. 환불 요청 방법</h3>
            <p>고객센터 또는 이메일을 통해 환불 요청이 가능합니다.</p>
            <p>환불 요청 시 다음 정보를 포함해주시기 바랍니다:</p>
            <ul>
              <li>결제 일시 및 주문번호</li>
              <li>결제 금액 및 구매 내역</li>
              <li>환불 사유</li>
              <li>환불 받으실 계좌 정보 (계좌이체 환불 시)</li>
            </ul>
          </section>

          <section>
            <h3>6. 고객센터</h3>
            <p>이메일: mathtailer@naver.com</p>
            <p>문의 가능 시간: 평일 09:00 ~ 18:00 (주말 및 공휴일 제외)</p>
          </section>

          <section>
            <h3>7. 기타 유의사항</h3>
            <ul>
              <li>본 환불 정책은 전자상거래 등에서의 소비자보호에 관한 법률 등 관련 법령을 준수합니다.</li>
              <li>환불 정책은 서비스 운영 정책에 따라 변경될 수 있으며, 변경 시 사전 공지합니다.</li>
              <li>본 정책에 명시되지 않은 사항은 관련 법령 및 상관례에 따릅니다.</li>
            </ul>
          </section>

          <p className="footer-date">최종 업데이트: 2026년 6월 13일</p>
        </div>
      </div>
    </div>
  );
};

export default RefundPolicyModal;
